import * as actions from './actions';
import * as getters from './getters';
import mutations from './mutations';


export default {
  namespaced: true,
  state: {
    error: '',
    isLoading: false,
    items: [],
    position: {},
    track: 'none',
    buttonVolume: 0,
    musicVolume: 0,
    steps: 0,
    days: 0,
    pendingTrainerWin: null,
  },
  actions,
  getters,
  mutations,
};


